import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signIn } from "../api/auth.js";
import GoogleSignInButton from "../components/GoogleSignInButton.jsx";

// Optional account screen — username + password, nothing else. Sign in and
// sign up share one card (tabbed); success returns to where you came from.
export default function AuthScreen() {
  const navigate = useNavigate();
  const [mode, setMode] = useState("login"); // "login" | "signup"
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [googleAvailable, setGoogleAvailable] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setError(null);
    setBusy(true);
    const r = await signIn(username.trim(), password, mode);
    setBusy(false);
    if (r.error) setError(r.error);
    else finish();
  };

  const finish = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/");
  };

  return (
    <main className="page auth-page">
      <div className="page-content">
        <div className="auth-card">
          <div className="auth-tabs" role="tablist">
            <button
              type="button"
              className={`chip${mode === "login" ? " active" : ""}`}
              onClick={() => { setMode("login"); setError(null); }}
            >
              Sign in
            </button>
            <button
              type="button"
              className={`chip${mode === "signup" ? " active" : ""}`}
              onClick={() => { setMode("signup"); setError(null); }}
            >
              Sign up
            </button>
        </div>
          <h1 className="page-heading">{mode === "login" ? "Welcome back" : "Create an account"}</h1>
          <p className="auth-hint">
            Optional — only for syncing your watch progress and My List across devices.
          </p>
          <GoogleSignInButton onDone={finish} onAvailability={(avail) => setGoogleAvailable(avail)} />
          {googleAvailable && (
            <>
              <div className="auth-divider" role="separator">
                <span>or</span>
              </div>
              <h2 className="auth-section-label">Use email & password</h2>
            </>
          )}
          <form onSubmit={submit}>
            <label className="auth-field">
              <span>Username</span>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                placeholder="3-20 letters, numbers, _"
                required
              />
            </label>
            <label className="auth-field">
              <span>Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete={mode === "login" ? "current-password" : "new-password"}
                placeholder="At least 4 characters"
                required
              />
            </label>
            {error && <p className="auth-error">{error}</p>}
            <button className="btn btn-primary auth-submit" type="submit" disabled={busy}>
              {busy ? "One moment…" : mode === "login" ? "Sign in" : "Create account"}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}
